import React from "react";
import classNames from "classnames";
import "./index.scss";

type Props = {
  icon: string;
  isConfirm: boolean;
  title?: string;
  size?: "small" | "medium" | "large" | "x-large";
};

const ShowConfirm = ({ icon, title, size, isConfirm }: Props) => {
  return (
    <section id={`show-confirm-container`}>
      <div className={isConfirm === true ? "success" : "danger"}>
        {title && (
          <div className="tooltip-hover">
            <span>{title}</span>
            <div className="after-arrow"></div>
          </div>
        )}
        <i className={classNames(icon, ` ${size}`, "icon")}></i>
      </div>
    </section>
  );
};

export default ShowConfirm;
